<template>
    <login-personalize-preview-panel-section
        class="login-personalize-preview-section-ssid"
    >
        <app-button
            type="button"
            label="Editar SSIDs"
            bordered
            @click="showSSIDModal = true"
        />

        <modal
            v-model="showSSIDModal"
            max-width="800"
            content-class="access-point-controller-list"
            title="Editar SSID's"
        >
            <form class="ssid-form" @submit.prevent="save">
                <SSIDFilter
                    v-model="form.ssidFilter"
                    :is-all-selected="form.allSsidSelected"
                    @update-all-selected="($event) => (form.allSsidSelected = $event)"
                />
                <app-button class="btn btn-primary btn-round" label="Salvar" type="submit" primary />
            </form>
        </modal>
    </login-personalize-preview-panel-section>
</template>

<script>
import LoginPersonalizeLocalModal from "@components/modules/login-personalize/local/modal/LoginPersonalizeLocalModal";
import LoginPersonalizePreviewPanelSection from "@components/modules/login-personalize/preview/panel/section/LoginPersonalizePreviewPanelSection";
import SSIDFilter from "@components/modules/ssid/SSIDFilter.vue";
import AppButton from "@/components/generic/button/Button";
import Modal from "@/components/generic/Modal";
import { cloneDeep } from "lodash";

export default {
    components: {
        LoginPersonalizePreviewPanelSection,
        LoginPersonalizeLocalModal,
        SSIDFilter,
        Modal,
        AppButton
    },

    data() {
        return {
            showSSIDModal: false,
            form: {
                ssidFilter: [],
                allSsidSelected: true
            }
        };
    },

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    methods: {
        save() {
            const value = cloneDeep(this.item);

            Object.keys(this.form).forEach(key => {
                value[key] = this.form[key];
            })

            this.$emit("saved", value);

            this.showSSIDModal = false;
        },
    },

    created(){
        this.form = {
            ssidFilter: this.item.ssidFilter,
            allSsidSelected: this.item.allSsidSelected
        }
    }

};
</script>

<style lang="scss" scoped>
.login-personalize-preview-section-ssid {
    display: flex;
    justify-content: center;
}

.ssid-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
}
</style>
